import { observer } from 'mobx-react';
import React from 'react';
import { WidgetConfigurationProps } from 'controls/designer/features/widgets/widgetConfig';
import { Section } from 'controls/react/layout/section';
import { i18n } from 'core/localization';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AntInput } from 'controls/react/ant/antInput';
import { AntInputNumber } from 'controls/react/ant/antInputNumber';
import { GridToolbarVisibility } from 'areas/service-boards/widgets/grids/gridToolbarVisibility';
import { DataSourceDataGridConfigStore } from 'areas/data-sources/components/DataSourceDataGridWidget/editor/store';
import { DataSourceDataGridWidgetConfig } from 'areas/data-sources/components/DataSourceDataGridWidget/types';
import { DatasourceEditor } from 'controls/designer/features/widgets/datasources/shared/components/data-source-editor/datasourceEditor';
import { PivotSettings } from 'controls/designer/features/widgets/datasources/shared/pivotSettings';
import { TimePeriodSettingsSection } from 'controls/designer/features/widgets/datasources/shared/components/time-period-settings-section/timePeriodSettingsSection';

export const DataSourceDataGridWidgetConfigEditor = observer(
	class InnerWidget extends React.Component<WidgetConfigurationProps<DataSourceDataGridWidgetConfig>> {
		store: DataSourceDataGridConfigStore;

		constructor(props: WidgetConfigurationProps<DataSourceDataGridWidgetConfig>) {
			super(props);
			this.store = new DataSourceDataGridConfigStore(props);
		}

		render() {
			return (
				<Section>
					<Section appearance={'frame-top-only'} title={i18n('General')} childrenPadding={true}>
						<FormEntryNew label={i18n('Title')} model={this.store.props.config} modelField={'title'}>
							<AntInput />
						</FormEntryNew>
					</Section>
					<Section appearance={'frame-top-only'} title={i18n('Data')} childrenPadding={true}>
						<DatasourceEditor manager={this.store.manager} showRowEditor={false} />
						<FormEntryNew label={i18n('Decimal Numbers')} model={this.store.props.config} modelField={'decimalsNumber'}>
							<AntInputNumber min={0} max={8} />
						</FormEntryNew>
						<GridToolbarVisibility
							flags={this.props.config.gridToolbarVisibility}
							enabledFlags={['showViewSelector', 'showFilters']}
						/>
					</Section>
					<Section appearance={'frame-top-only'} title={i18n('Rows and Columns')} childrenPadding={true}>
						<PivotSettings store={this.store.pivotManager} />
					</Section>
					<TimePeriodSettingsSection store={this.store} model={this.store.props.config} />
				</Section>
			);
		}

		componentWillUnmount() {
			this.store?.destroy();
		}
	},
);
